import {
  Box,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import getMaterialSummaryData from "../../../../../service/materialSummaryService";

const MaterialSummary = ({ order, ...props }) => {
  let materialSummary = getMaterialSummaryData(order);

  if (order && materialSummary)
    return (
      <Box {...props}>
        <Typography variant="h6">Material Summary</Typography>
        <TableContainer component={Paper} sx={{ marginTop: "8px" }}>
          <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>Flats Needed To Complete Order + Extra FS</TableCell>
                <TableCell align="right">
                  {materialSummary.flatsNeeded} FS
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  Standalone Flat Sheets - not including what's needed for
                  requested parts
                </TableCell>
                <TableCell align="right">
                  {materialSummary.standaloneFlats} FS
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Total Galvanized Flats for Cleat</TableCell>
                <TableCell align="right">
                  {materialSummary.galvFlatsNeeded} FS
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  Standalone Coil Lineal Footage - not including what's needed
                  for panels
                </TableCell>
                <TableCell align="right">
                  {materialSummary.totalLinealFootOfStandaloneCoil} LF
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  Total Lineal Footage of Coil Needed to Complete Panels
                </TableCell>
                <TableCell align="right">
                  {materialSummary.totalLinealFootOfCoilNeededForPanels} LF
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Coil Width Needed to Create Panels</TableCell>
                <TableCell align="right">
                  {materialSummary.coilWidthNeededForPanels} in.
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Total Panel Coil Square Footage</TableCell>
                <TableCell align="right">
                  {materialSummary.totalPanelCoilSquareFeet} SF
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Total Panel Coil Square Footage inc Drop</TableCell>
                <TableCell align="right">
                  {materialSummary.totalPanelCoilSquareFeetIncDrop} SF
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Total Panel Area Coverage</TableCell>
                <TableCell align="right">
                  {materialSummary.totalPanelAreaCoverage} SF
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </Box>
    );
};

export default MaterialSummary;
